export class Pagination {
  elementsPerPage: number;
  page: number;
  totalElements: number;
  totalPages: number;
  searchText: string;
  sort: string;

  constructor(pagination?: {}) {
    if (!pagination) {
      pagination = {};
    }

    this.elementsPerPage = pagination['elementsPerPage'] || 10;
    this.page = pagination['page'] || 0;
    this.totalElements = pagination['totalElements'] || 0;
    this.totalPages = pagination['totalPages'] || 1;

    if (!!pagination['searchText']) {
      this.searchText = pagination['searchText'];
    }

    if (!!pagination['sort']) {
      this.sort = pagination['sort'];
    }
  }

}
